export default __webpack_public_path__ + "static/media/Thumb_Accessories_02.212c2984.png";